<template>
  <div class="data_brain_wrap">
    <!-- <div class="brain_title"></div>
    <div class="brain_desc"></div> -->
    <div class="swiper-container">
      <swiper :options="swiperOptions" ref="mySwiper">
        <swiper-slide class="swiperslide" v-for="(item, index) in slides" :key="index">
          <img :src="item.image" alt="slide" class="slide-image" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- <el-row class="card_wrap" type="flex">
      <el-col
        class="brain_item"
        :lg="7"
        :sm="11"
        :xs="11"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="item_title">{{ item.title }}</div>
        <div class="item_desc">{{ item.desc }}</div>
        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>
        <div class="item_bg"></div>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
const url = `https://omo-oss-image.thefastimg.com/portal-saas/new2023061311542249841/cms/image/`;
export default { 
  data() {
    return {
      swiperOptions: {
        effect: 'coverflow', // 使用 3D Flow 效果
        grabCursor: true, // 显示抓手光标
        centeredSlides: true, // 当前幻灯片居中
        slidesPerView: 'auto', // 自动根据容器宽度调整显示的幻灯片数量
        coverflowEffect: {
          rotate: 15, // 幻灯片旋转角度
          stretch: 160, // 幻灯片之间的间距
          depth: 50, // 深度效果
          // modifier: 1, // 效果强度
          slideShadows: true, // 是否显示阴影
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      slides: [
        { image: require('@/assets/img/zhengshu11.jpg') },
        { image: require('@/assets/img/zhengshu12.jpg') },
        { image: require('@/assets/img/zhengshu10.jpg') },
        { image: require('@/assets/img/zhengshu8.jpg') },
        { image: require('@/assets/img/zhengshu1.jpg') },
        { image: require('@/assets/img/zhengshu2.png') },
        { image: require('@/assets/img/zhengshu3.png') },
        { image: require('@/assets/img/zhengshu4.jpg') },
        { image: require('@/assets/img/zhengshu5.jpg') },
        { image: require('@/assets/img/zhengshu6.jpg') },
        { image: require('@/assets/img/zhengshu7.jpg') },
        { image: require('@/assets/img/zhengshu9.jpg') },
        { image: require('@/assets/img/zhengshu13.jpg') },
      ],
      cardList: [
        
      ],
    }
  },
  methods:{
    handleNavigate(){
      this.$router.push('/production/1').catch((v) => {})
    }
  }
}
</script>

<style lang="scss" >
.data_brain_wrap {
  .swiper-container{
    width: 100%;
    position: relative;
    .swiperslide{
      width: 343px;
      height: 504px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .swiper-pagination {
      position: relative;
      bottom: 1px; /* 调整分页器距离底部的距离 */
      left: 50%; /* 水平居中 */
      transform: translateX(-50%); /* 水平居中 */
    }
  }
  
  padding: 50px 0;
  // background: #e8eef2;
  text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
    }
  }
  .card_wrap {
    width: 70%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20PX;
        &:nth-child(-n+2){
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg{
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110PX;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100PX;
        height: 30PX;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          font-size: 14px;
        }
      }
    }
  }
}
</style>